import { ImageSourcePropType } from 'react-native'
import { Images } from 'src/assets/Images'

export class WhitelabelHelper {
  public static getLogoSource = (): ImageSourcePropType => Images.loginLogo as ImageSourcePropType
}
